<template>
  <transition name="toast-fade">
    <div v-if="show" class="toast-container" :class="type">
      <div class="toast-content">
        <!-- Иконка в зависимости от типа -->
        <div class="toast-icon">
          <img v-if="type === 'success'" src="@/assets/images/icons/checked.svg" alt="Success" class="icon-svg" />
          <span v-else-if="type === 'error'">✕</span>
          <span v-else>ℹ</span>
        </div>
        <div class="toast-text">
          {{ message }}
        </div>
      </div>
      <div class="toast-progress" :style="{ animationDuration: '3s' }"></div>
    </div>
  </transition>
</template>

<script setup>
  import { computed } from 'vue';
  import { useStore } from 'vuex';

  const store = useStore();

  const show = computed(() => store.state.notifications.show);
  const message = computed(() => store.state.notifications.message);
  const type = computed(() => store.state.notifications.type);
</script>

<style scoped lang="scss">
  .toast-container {
    position: fixed;
    right: 40px;
    bottom: 40px;
    z-index: 10000;

    min-width: 300px;
    max-width: 450px;
    padding: 16px 20px;
    overflow: hidden;

    background: #fff;
    border: 1px solid #f0f0f0;
    border-radius: 16px;
    box-shadow: 0 12px 32px rgb(0 0 0 / 15%);

    &.success {
      border-left: 6px solid #58b251;
    }

    &.error {
      border-left: 6px solid #d44233;
    }

    &.info {
      border-left: 6px solid #0066ce;
    }

    .toast-content {
      display: flex;
      gap: 15px;
      align-items: center;
    }

    .toast-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 28px;
      height: 28px;

      border-radius: 50%;

      .icon-svg {
        width: 20px;
        height: 20px;
      }
    }

    .toast-text {
      color: #3e3e3e;
      font-weight: 500;
      font-size: 15px;
      line-height: 1.4;
    }

    /* Полоска прогресса (опционально) */
    .toast-progress {
      position: absolute;
      bottom: 0;
      left: 0;

      width: 100%;
      height: 3px;

      background: rgb(0 0 0 / 5%);
      transform-origin: left;

      animation: shrink linear forwards;
    }
  }

  /* Анимации появления */
  .toast-fade-enter-active {
    animation: slide-in 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  }

  .toast-fade-leave-active {
    transition: all 0.3s ease;
  }

  .toast-fade-leave-to {
    transform: translateX(100px);
    opacity: 0;
  }

  @keyframes slide-in {
    from {
      transform: translateY(100px) scale(0.8);
      opacity: 0;
    }

    to {
      transform: translateY(0) scale(1);
      opacity: 1;
    }
  }

  @keyframes shrink {
    from {
      transform: scaleX(1);
    }

    to {
      transform: scaleX(0);
    }
  }
</style>
